import React from 'react';
import { cn } from '../../lib/utils';

const Field = React.forwardRef(({ className, orientation = "vertical", ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "flex",
        orientation === "horizontal" ? "items-center gap-4" : "flex-col gap-2",
        className
      )}
      {...props}
    />
  );
});

const FieldLabel = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <label
      ref={ref}
      className={cn(
        "text-sm font-medium text-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      )}
      {...props}
    />
  );
});

const FieldDescription = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  );
});

const FieldError = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn("text-sm font-medium text-destructive", className)}
      {...props}
    />
  );
});

Field.displayName = "Field";
FieldLabel.displayName = "FieldLabel";
FieldDescription.displayName = "FieldDescription";
FieldError.displayName = "FieldError";

export { Field, FieldLabel, FieldDescription, FieldError };